import {Link} from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function TicketMenu(){

const userGroup = localStorage.getItem('userGroup');

const MenuCard = ({link,title,icon,color}) => (

<div className="col-xl-3 col-lg-4 col-md-6 mb-4">

<Link to={link} className="menu-link">

<div className="menu-card" style={{borderTop:`4px solid ${color}`}}>

<div className="menu-icon" style={{color:color}}>
<FontAwesomeIcon icon={icon} size="2x"/>
</div>

<p className="menu-title">{title}</p>

</div>

</Link>

</div>

)

return(

<section className="container-fluid mt-4">

<h5 className="menu-section-title">Ticketing System</h5>

<div className="row">

<MenuCard link="/ticketing" title="Raise Ticket" icon="fa-solid fa-ticket" color="#0d6efd"/>

{userGroup === "Admin" && (
<MenuCard link="/ticket-response" title="Ticket Response" icon="fa-solid fa-reply" color="#dc3545"/>
)}

</div>

</section>

)

}

export default TicketMenu;